module.exports = __webpack_public_path__ + "static/img/main.55db039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/11/main.png
// module id = 8p/p
// module chunks = 1